import { useEffect } from "react";
import { reportError } from "../../monitoring/reportError";
import { devError } from "../../utils/devLog";

const LoadScripts = () => {
  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const scripts = [
      `${process.env.PUBLIC_URL}/assets/js/main.js`,
    ];

    const loadAllScripts = async () => {
      for (const script of scripts) {
        try {
          await loadScript(script);
        } catch (error) {
          devError(`Failed to load script ${script}:`, error);
          reportError(error, { fatal: false, source: "script.load" });
        }
      }
    };

    loadAllScripts();
  }, []);

  return null;
};

export default LoadScripts;
